module.exports = __webpack_public_path__ + "img/logo.2de953fc.png";